import React, { useState } from 'react';
import '../../styles/Auth/forgotPasswordPopUp.css';
import { postData, getData } from "../../webService/webservice.js";
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaHouse } from 'react-icons/fa6';

const ForgotPasswordPopup = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle'); // idle, success, error
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const handleSendLink = async () => {
        if (!email.includes('@')) {
            setStatus('error');
            setMessage('Please enter a valid email address.');
            return;
        }

        setIsLoading(true);
        setStatus('idle');
        setMessage('');

        try {
            const response = await postData('users/user/forgotpassword', { email });

            setStatus('success');
            setMessage(response.data.message || `A password reset link has been sent to ${email}`);
        } catch (error) {
            setStatus('error');
            const msg =
                error.response?.data?.message || 'Failed to send reset link. Please try again.';
            setMessage(msg);
        } finally {
            setIsLoading(false);
        }

    };
    const [backgroundImages, setBackgroundImages] = useState([]);
    const [bgIndex, setBgIndex] = useState(0);

    React.useEffect(() => {
        const fetchBackgrounds = async () => {
            try {
                const response = await getData('appearance/backgrounds');
                if (response?.data?.results) {
                    const images = response.data.results
                        .filter(bg => bg?.uri)
                        .map(bg => {
                            const baseUrl = process.env.REACT_APP_API_URL.replace(/\/$/, "");
                            const uri = bg.uri.replace(/^\/?/, "/");
                            return `${baseUrl}${uri}`;
                        });

                    console.log("Background Images:", images);
                    setBackgroundImages(images);
                }
            } catch (error) {
                console.error("Failed to load backgrounds:", error);
            }
        };
        fetchBackgrounds();
    }, []);

    React.useEffect(() => {
        if (backgroundImages.length === 0) return;
        const interval = setInterval(() => {
            setBgIndex((prev) => (prev + 1) % backgroundImages.length);
        }, 6000);
        return () => clearInterval(interval);
    }, [backgroundImages]);

    return (
        <div className='forgot-password-bg'>
            <div className="login-bg-overlay"></div>
            {backgroundImages.map((img, index) => (
                <div
                    key={index}
                    className={`login-bg-img ${index === bgIndex ? 'active' : ''}`}
                    style={{
                        backgroundImage: `url("${img}")`
                    }}
                />
            ))}

            <div className='forgot-password-container'>
                <div className='forgot-password-card'>
                    <div className='forgot-password-form'>
                        <div className='forgot-password-logo'>
                            <img className='logo' src='/assets/logo.png' alt='logo' />
                            <p className='forgot-password-title'>Reset Password</p>
                        </div>

                        {status === 'success' ? (
                            <>
                                <p style={{ color: 'white', fontSize: '14px', textAlign: 'center', marginBottom: '20px' }}>
                                    {message}
                                </p>
                                <div className="forgot-password-button">
                                    <button
                                        className="forgot-password-btn-main"
                                        onClick={() => navigate('/login')}
                                    >
                                        Return to Sign In
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className='forgot-password-input-group'>
                                    <FaEnvelope className='login-input-icon' />
                                    <input
                                        type="email"
                                        placeholder="Enter Your Email Id"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        className="forgot-password-input"
                                    />
                                </div>

                                {status === 'error' && (
                                    <p style={{ color: '#ff4d4d', fontSize: '13px', marginBottom: '15px', textAlign: 'center', fontWeight: '500' }}>
                                        {message}
                                    </p>
                                )}

                                <div className='forgot-password-button'>
                                    <button
                                        className='forgot-password-btn-main'
                                        onClick={handleSendLink}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? 'Sending...' : 'Send Reset Link'}
                                    </button>
                                </div>
                                <p
                                    className='forgot-password-link'
                                    onClick={() => navigate('/login')}
                                >
                                    <FaHouse size={18} /> Go to Sign In
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPopup;
